import { render } from "./ProjektSide.vue?vue&type=template&id=8290d548"
import script from "./ProjektSide.vue?vue&type=script&lang=js"
export * from "./ProjektSide.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__